import React from 'react'
import { OpenTrend } from '../Trends/OpenTrend'

function OpenTrends() {
  return (
    <>
        <OpenTrend />
    </>
  )
}

export default OpenTrends
